import {ButtonProps} from './components/button';

export const locales: Locale[] = ['en', 'fr', 'de'];

export const homePageSlug: string = 'homepage';

export const now = new Date();

export const defaultSlugs: Alternate = {
  en: '/',
  fr: '/fr/',
  de: '/de/',
};

export const localeInLanguages: Alternate = {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
  };

export const publishedLocale: Locale[] = ['en', 'fr', 'de'];
export const defaultLocale: Locale = 'en';
export const homePageId = 931921;
export const demoId = '1004820';
export const enventPageId = '1220806';

export const parametersTracked = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid'];

export const pageModels = [
    'DatoCmsBlogsList',
    'DatoCmsPodcastsList',
    'DatoCmsDocumentPage',
    'DatoCmsVideoPage',
    'DatoCmsEventPage',
    'DatoCmsWebinarPage',
    'DatoCmsPressPage',
    'DatoCmsCustomersList',
    
    // 'DatoCmsCreatePage',
    'DatoCmsCustomer',
    // 'DatoCmsSolution',
    // 'DatoCmsSolutionPage',
    'DatoCmsSimplePage',
    'DatoCmsWebinar',
    'DatoCmsBlog',
    'DatoCmsBlogCategory',
    'DatoCmsPodcast',
    'DatoCmsPodcastCategory',
    'DatoCmsCustomerCategory',
    'DatoCmsContactPage',
    'DatoCmsPartner',
    'DatoCmsPartnerPage',
    'DatoCmsPartnerCategory',
    // 'DatoCmsDocumentCategory',
    'DatoCmsDocument',
    'DatoCmsVideoCategory',
    'DatoCmsVideoModel',
    'DatoCmsEvent',
    'DatoCmsPress',
    'DatoCmsWhatsNewPage',
    'DatoCmsWhatsNewCategory',
    'DatoCmsNewSolution',

    'DatoCmsContentHubPage',
    'DatoCmsMicrositePage'
    // 'DatoCmsContentHubVideoHub',
];

// Trial IDs
// IMPORTANT: The A/B/C test is controlled by the BRANCH environment variable at build time.
// Set BRANCH to 'master', 'master-b', or 'master-c' in your build/deploy environment to select the correct variant.
// For Netlify, set this in Site settings > Build & deploy > Environment, or in netlify.toml per branch context.


export const newDemoId = '148966459';

export const testBranches = ['master-b', 'master-c', 'master'];


export const pricingPageId = '982852';
export const newPricingPageId = 'U1PAC4ITQSSg4-f7SFAljQ';


export const regexPageId = /^@[A-z0-9_-]+(#[A-z0-9_-]+)?$/;

export const screens = {
    'sm': '640px',
    'md': '768px',
    'lg': '1024px',
    'xl': '1280px',
    '2xl': '1536px'
}

export const colors: { [key in Color]: Color; } = {
    pepper: 'pepper',
    midnight: 'midnight',
    silver: 'silver',
    white: 'white',
    spicytalks19: 'spicytalks19',
    spicytalks22: 'spicytalks22',
    create23: 'create23'
};

export const categoriesCss: Color2String = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-midnight',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white',
    white: 'text-midnight'
};

export const titlesCss: Color2String = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-pepper',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white',
    white: 'text-pepper'
};

export const leadsCss: Color2String = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-outer-space',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white',
    white: 'text-outer-space'
};

export const buttonColors: { [key in Color]: ButtonProps['color']; } = {
    pepper: 'blurple',
    midnight: 'pepper',
    silver: 'blurple',
    spicytalks19: 'blurple',
    spicytalks22: 'blurple',
    create23: 'blurple',
    white: 'blurple',
};

export const textSizes = {
    medium: 'prose-lg',
    regular: 'prose-xl',
    large: 'prose-2xl',
    xlarge: 'prose-2xl'
};

export const textSizesResearch = {
    medium: 'prose-2xl',
    regular: 'prose-2xl',
    large: 'prose-2xl',
    xlarge: 'prose-2xl'
};

export const logoCss = {
    pepper: 'bg-pepper',
    midnight: 'bg-midnight',
    silver: 'bg-silver',
    white: 'bg-white'
}

export const logoMonochrome = {
    pepper: 'logosWhite',
    midnight: 'logosWhite',
    silver: 'logosGrey',
    white: 'logosGrey',
}

export const textCategoryCss = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-pepper',
    white: 'text-pepper',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white'
};

export const textCss = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-midnight',
    white: 'text-midnight',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white'
};

export const defaultTextColor = {
    pepper: 'white',
    midnight: 'white',
    silver: 'grey',
    white: 'grey',
    spicytalks19: 'white',
    spicytalks22: 'white',
    create23: 'white'
};

export const defaultTitleColor = {
    pepper: 'white',
    midnight: 'white',
    silver: 'midnight',
    white: 'midnight',
    spicytalks19: 'white',
    spicytalks22: 'white',
    create23: 'white'
};

export const bgGradientCss = {
    white: 'bg-white',
    pepper: 'bg-pepper-gradient',
    midnight: 'bg-midnight-gradient',
    silver: 'bg-silver',
    spicytalks19: 'bg-midnight-gradient',
    spicytalks22: 'bg-midnight-gradient',
    create23: 'bg-midnight-gradient'
};

export const bgCss = {
    pepper: 'bg-pepper',
    midnight: 'bg-midnight',
    silver: 'bg-silver',
    spicytalks19: 'bg-midnight',
    spicytalks22: 'bg-midnight',
    create23: 'bg-pepper'
};

export const documentTextCss = {
    pepper: 'text-white',
    midnight: 'text-white',
    silver: 'text-outer-space',
    white: 'text-outer-space',
    spicytalks19: 'text-white',
    spicytalks22: 'text-white',
    create23: 'text-white'
}

export const textColorResearchCss = {
    Navy: 'text-navy-research',
    White: 'text-white',
}

export const textColorCss = {
    pepper: 'text-pepper',
    midnight: 'text-midnight',
    blurple: 'text-blurple',
    grey: 'text-outer-space',
    white: 'text-white',
    black: 'text-black'
}

export const backgrounds: Omit<Color2String, 'white'> = {
	pepper: 'https://chili.imgix.net/test/header-bg-pepper-large.jpg',
	midnight: 'https://chili.imgix.net/test/header-bg-midnight-large.jpg',
	silver: 'https://chili.imgix.net/test/header-bg-silver-large.jpg',
    spicytalks19: 'https://chili.imgix.net/test/header-bg-spicytalks19-large.jpg',
	spicytalks22: 'https://chili.imgix.net/test/header-bg-spicytalks22-1-large.png',
    create23: 'https://chili.imgix.net/test/header-bg-create23-1-large.png',
};

export const defaultAlign: Lowercase<OrientationLCR> = 'center';

export const aligns: {[key in Lowercase<OrientationLCR>]: string} = {
	center: 'text-center',
	left: 'text-left',
	right: 'text-right'
}

export const coverRatio = 1200/720;

export const defaultColor: Color = 'pepper';

export const SwitchColorsBlur: SwitchColorsCss = {
    'Jungle': 'bg-jungle/[.6]',
    'Magenta': 'bg-magenta/[.2]',
    'Orangina': 'bg-orangina/[.25]',
    'Azure': 'bg-azure/[.15]',
    'Folly': 'bg-folly/[.2]',
    'Red': 'bg-red/[.4]',
    'Teal': 'bg-forest/[.4]',
    'Purple': 'bg-purple/[.4]',
    'Orange': 'bg-[#FF8C00]/[.4]'  
}

export const AC_FIELD_IDS = {
    // UTM Fields
    UTM_SOURCE: 'field[48]',
    UTM_MEDIUM: 'field[49]',
    UTM_CAMPAIGN: 'field[74]',
    UTM_TERM: 'field[75]',
    UTM_CONTENT: 'field[76]',
    
    // Tracking Fields
    GCLID: 'field[25]',
    FBCLID: 'field[51]',
    LIFATID: 'field[56]',
    UNKNOWN_57: 'field[57]',
    
    // Page/Form Fields
    RECENT_PAGE: 'field[58]',
    FORM_NAME: 'field[62]',
    LANDING_PAGE: 'field[64]',
    REFERRER: 'field[67]',
    
    // Timestamp Fields
    UTM_TIMESTAMP_DATE: 'field[61][date]',
    UTM_TIMESTAMP_TIME: 'field[61][time]',
    UTM_TIMESTAMP_TEXT: 'field[70]',
    FORM_TIMESTAMP: 'field[80]',
    
    // Other Fields
    LANGUAGE: 'field[7]',
    WHITEPAPER_KEY: 'field[34]',
    HONEYPOT: 'field[37]',
    COUNTRY: 'field[3]',
    
    // Customer Account Fields
    COUNTRY_CA: 'ca[7]',
    PHONE_CA: 'ca[11]',
  } 

// const NEAL_LINK = 'https://calendly.com/nealprabhu/30min';
// const ERIK_LINK = 'https://calendly.com/edevolder/30min';
// const NABIL_LINK = 'https://calendly.com/nfarhati/30min';
// const JADE_LINK = 'https://calendly.com/jfinlayson-69cz/30min';
// const JADE_LINK = ERIK_LINK;

// export const bookingLinks = {
//     'LATAM': NEAL_LINK,
//     'NA': NEAL_LINK, 
//     'Benelux': ERIK_LINK, 
//     'DACH': NABIL_LINK, 
//     'EEU': NABIL_LINK, 
//     'France': ERIK_LINK, 
//     'MENA': NABIL_LINK, 
//     'Nordics': JADE_LINK, 
//     'ROEU': NABIL_LINK, 
//     'SEU': NABIL_LINK, 
//     'UKIRE': JADE_LINK, 
//     'APAC': NABIL_LINK, 
//     'ROW': ERIK_LINK
// }

export const countries = [
    {iso: 'AD',	value: 'Andorra', currency: 'USD', zone: 'ROW', label: { en: 'Andorra', fr: null, de: null}},
    {iso: 'AE',	value: 'United Arab Emirates', currency: 'USD', zone: 'ROW', label: { en: 'United Arab Emirates', fr: null, de: null}},
    {iso: 'AF',	value: 'Afghanistan', currency: 'USD', zone: 'ROW', label: { en: 'Afghanistan', fr: null, de: null}},
    {iso: 'AG',	value: 'Antigua and Barbuda', currency: 'USD', zone: 'ROW', label: { en: 'Antigua and Barbuda', fr: null, de: null}},
    {iso: 'AI',	value: 'Anguilla', currency: 'USD', zone: 'ROW', label: { en: 'Anguilla', fr: null, de: null}},
    {iso: 'AL',	value: 'Albania', currency: 'USD', zone: 'ROW', label: { en: 'Albania', fr: null, de: null}},
    {iso: 'AM',	value: 'Armenia', currency: 'USD', zone: 'ROW', label: { en: 'Armenia', fr: null, de: null}},
    {iso: 'AO',	value: 'Angola', currency: 'USD', zone: 'ROW', label: { en: 'Angola', fr: null, de: null}},
    {iso: 'AQ',	value: 'Antarctica', currency: 'USD', zone: 'ROW', label: { en: 'Antarctica', fr: null, de: null}},
    {iso: 'AR',	value: 'Argentina', currency: 'USD', zone: 'LATAM', label: { en: 'Argentina', fr: null, de: null}},
    {iso: 'AT',	value: 'Austria', currency: 'EUR', zone: 'DACH', label: { en: 'Austria', fr: null, de: null}},
    {iso: 'AU',	value: 'Australia', currency: 'USD', zone: 'ROW', label: { en: 'Australia', fr: null, de: null}},
    {iso: 'AW',	value: 'Aruba', currency: 'USD', zone: 'ROW', label: { en: 'Aruba', fr: null, de: null}},
    {iso: 'AX',	value: 'Aland Islands', currency: 'USD', zone: 'ROW', label: { en: 'Aland Islands', fr: null, de: null}},
    {iso: 'AZ',	value: 'Azerbaijan', currency: 'USD', zone: 'ROW', label: { en: 'Azerbaijan', fr: null, de: null}},
    {iso: 'BA',	value: 'Bosnia and Herzegovina', currency: 'USD', zone: 'ROW', label: { en: 'Bosnia and Herzegovina', fr: null, de: null}},
    {iso: 'BB',	value: 'Barbados', currency: 'USD', zone: 'ROW', label: { en: 'Barbados', fr: null, de: null}},
    {iso: 'BD',	value: 'Bangladesh', currency: 'USD', zone: 'ROW', label: { en: 'Bangladesh', fr: null, de: null}},
    {iso: 'BE',	value: 'Belgium', currency: 'EUR', zone: 'Benelux', label: { en: 'Belgium', fr: null, de: null}},
    {iso: 'BF',	value: 'Burkina Faso', currency: 'USD', zone: 'ROW', label: { en: 'Burkina Faso', fr: null, de: null}},
    {iso: 'BG',	value: 'Bulgaria', currency: 'USD', zone: 'ROW', label: { en: 'Bulgaria', fr: null, de: null}},
    {iso: 'BH',	value: 'Bahrain', currency: 'USD', zone: 'ROW', label: { en: 'Bahrain', fr: null, de: null}},
    {iso: 'BI',	value: 'Burundi', currency: 'USD', zone: 'ROW', label: { en: 'Burundi', fr: null, de: null}},
    {iso: 'BJ',	value: 'Benin', currency: 'USD', zone: 'ROW', label: { en: 'Benin', fr: null, de: null}},
    {iso: 'BL',	value: 'Saint Barthélemy', currency: 'USD', zone: 'ROW', label: { en: 'Saint Barthélemy', fr: null, de: null}},
    {iso: 'BM',	value: 'Bermuda', currency: 'USD', zone: 'ROW', label: { en: 'Bermuda', fr: null, de: null}},
    {iso: 'BN',	value: 'Brunei Darussalam', currency: 'USD', zone: 'ROW', label: { en: 'Brunei Darussalam', fr: null, de: null}},
    {iso: 'BO',	value: 'Bolivia, Plurinational State of', currency: 'USD', zone: 'ROW', label: { en: 'Bolivia', fr: null, de: null}},
    {iso: 'BQ',	value: 'Bonaire, Sint Eustatius, and Saba', currency: 'USD', zone: 'ROW', label: { en: 'Bonaire, Sint Eustatius, and Saba', fr: null, de: null}},
    {iso: 'BR',	value: 'Brazil', currency: 'USD', zone: 'LATAM', label: { en: 'Brazil', fr: null, de: null}},
    {iso: 'BS',	value: 'Bahamas', currency: 'USD', zone: 'ROW', label: { en: 'Bahamas', fr: null, de: null}},
    {iso: 'BT',	value: 'Bhutan', currency: 'USD', zone: 'ROW', label: { en: 'Bhutan', fr: null, de: null}},
    {iso: 'BV',	value: 'Bouvet Island', currency: 'USD', zone: 'ROW', label: { en: 'Bouvet Island', fr: null, de: null}},
    {iso: 'BW',	value: 'Botswana', currency: 'USD', zone: 'ROW', label: { en: 'Botswana', fr: null, de: null}},
    {iso: 'BY',	value: 'Belarus', currency: 'USD', zone: 'ROW', label: { en: 'Belarus', fr: null, de: null}},
    {iso: 'BZ',	value: 'Belize', currency: 'USD', zone: 'ROW', label: { en: 'Belize', fr: null, de: null}},
    {iso: 'CA',	value: 'Canada', currency: 'USD', zone: 'NA', label: { en: 'Canada', fr: null, de: null}},
    {iso: 'CC',	value: 'Cocos (Keeling) Islands', currency: 'USD', zone: 'ROW', label: { en: 'Cocos (Keeling) Islands', fr: null, de: null}},
    {iso: 'CD',	value: 'Congo, the Democratic Republic of the', currency: 'USD', zone: 'ROW', label: { en: 'Congo, the Democratic Republic of the', fr: null, de: null}},
    {iso: 'CF',	value: 'Central African Republic', currency: 'USD', zone: 'ROW', label: { en: 'Central African Republic', fr: null, de: null}},
    {iso: 'CG',	value: 'Congo', currency: 'USD', zone: 'ROW', label: { en: 'Congo', fr: null, de: null}},
    {iso: 'CH',	value: 'Switzerland', currency: 'EUR', zone: 'DACH', label: { en: 'Switzerland', fr: null, de: null}},
    {iso: 'CI',	value: 'Cote d’Ivoire', currency: 'USD', zone: 'ROW', label: { en: 'Cote d\'Ivoire', fr: null, de: null}},
    {iso: 'CK',	value: 'Cook Islands', currency: 'USD', zone: 'ROW', label: { en: 'Cook Islands', fr: null, de: null}},
    {iso: 'CL',	value: 'Chile', currency: 'USD', zone: 'LATAM', label: { en: 'Chile', fr: null, de: null}},
    {iso: 'CM',	value: 'Cameroon', currency: 'USD', zone: 'ROW', label: { en: 'Cameroon', fr: null, de: null}},
    {iso: 'CN',	value: 'China', currency: 'USD', zone: 'ROW', label: { en: 'China', fr: null, de: null}},
    {iso: 'CO',	value: 'Colombia', currency: 'USD', zone: 'LATAM', label: { en: 'Colombia', fr: null, de: null}},
    {iso: 'CR',	value: 'Costa Rica', currency: 'USD', zone: 'LATAM', label: { en: 'Costa Rica', fr: null, de: null}},
    {iso: 'CV',	value: 'Cape Verde', currency: 'USD', zone: 'ROW', label: { en: 'Cape Verde', fr: null, de: null}},
    {iso: 'CW',	value: 'Curaçao', currency: 'USD', zone: 'ROW', label: { en: 'Curaçao', fr: null, de: null}},
    {iso: 'CX',	value: 'Christmas Island', currency: 'USD', zone: 'ROW', label: { en: 'Christmas Island', fr: null, de: null}},
    {iso: 'CY',	value: 'Cyprus', currency: 'USD', zone: 'ROW', label: { en: 'Cyprus', fr: null, de: null}},
    {iso: 'CZ',	value: 'Czechia', currency: 'EUR', zone: 'EEU', label: { en: 'Czechia', fr: null, de: null}},
    {iso: 'DE',	value: 'Germany', currency: 'EUR', zone: 'DACH', label: { en: 'Germany', fr: null, de: null}},
    {iso: 'DJ',	value: 'Djibouti', currency: 'USD', zone: 'ROW', label: { en: 'Djibouti', fr: null, de: null}},
    {iso: 'DK',	value: 'Denmark', currency: 'EUR', zone: 'Nordics', label: { en: 'Denmark', fr: null, de: null}},
    {iso: 'DM',	value: 'Dominica', currency: 'USD', zone: 'ROW', label: { en: 'Dominica', fr: null, de: null}},
    {iso: 'DO',	value: 'Dominican Republic', currency: 'USD', zone: 'ROW', label: { en: 'Dominican Republic', fr: null, de: null}},
    {iso: 'DZ',	value: 'Algeria', currency: 'USD', zone: 'MENA', label: { en: 'Algeria', fr: null, de: null}},
    {iso: 'EC',	value: 'Ecuador', currency: 'USD', zone: 'ROW', label: { en: 'Ecuador', fr: null, de: null}},
    {iso: 'EE',	value: 'Estonia', currency: 'EUR', zone: 'EEU', label: { en: 'Estonia', fr: null, de: null}},
    {iso: 'EG',	value: 'Egypt', currency: 'USD', zone: 'MENA', label: { en: 'Egypt', fr: null, de: null}},
    {iso: 'EH',	value: 'Western Sahara', currency: 'USD', zone: 'ROW', label: { en: 'Western Sahara', fr: null, de: null}},
    {iso: 'ER',	value: 'Eritrea', currency: 'USD', zone: 'ROW', label: { en: 'Eritrea', fr: null, de: null}},
    {iso: 'ES',	value: 'Spain', currency: 'EUR', zone: 'SEU', label: { en: 'Spain', fr: null, de: null}},
    {iso: 'ET',	value: 'Ethiopia', currency: 'USD', zone: 'ROW', label: { en: 'Ethiopia', fr: null, de: null}},
    {iso: 'FI',	value: 'Finland', currency: 'EUR', zone: 'Nordics', label: { en: 'Finland', fr: null, de: null}},
    {iso: 'FJ',	value: 'Fiji', currency: 'USD', zone: 'ROW', label: { en: 'Fiji', fr: null, de: null}},
    {iso: 'FK',	value: 'Falkland Islands (Malvinas)', currency: 'USD', zone: 'ROW', label: { en: 'Falkland Islands (Malvinas)', fr: null, de: null}},
    {iso: 'FO',	value: 'Faroe Islands', currency: 'USD', zone: 'ROW', label: { en: 'Faroe Islands', fr: null, de: null}},
    {iso: 'FR',	value: 'France', currency: 'EUR', zone: 'France', label: { en: 'France', fr: null, de: null}},
    {iso: 'GA',	value: 'Gabon', currency: 'USD', zone: 'ROW', label: { en: 'Gabon', fr: null, de: null}},
    {iso: 'GB',	value: 'United Kingdom', currency: 'GBP', zone: 'UKIRE', label: { en: 'United Kingdom', fr: null, de: null}},
    {iso: 'GD',	value: 'Grenada', currency: 'USD', zone: 'ROW', label: { en: 'Grenada', fr: null, de: null}},
    {iso: 'GE',	value: 'Georgia', currency: 'USD', zone: 'ROW', label: { en: 'Georgia', fr: null, de: null}},
    {iso: 'GF',	value: 'French Guiana', currency: 'USD', zone: 'ROW', label: { en: 'French Guiana', fr: null, de: null}},
    {iso: 'GG',	value: 'Guernsey', currency: 'USD', zone: 'ROW', label: { en: 'Guernsey', fr: null, de: null}},
    {iso: 'GH',	value: 'Ghana', currency: 'USD', zone: 'ROW', label: { en: 'Ghana', fr: null, de: null}},
    {iso: 'GI',	value: 'Gibraltar', currency: 'USD', zone: 'ROW', label: { en: 'Gibraltar', fr: null, de: null}},
    {iso: 'GL',	value: 'Greenland', currency: 'USD', zone: 'ROW', label: { en: 'Greenland', fr: null, de: null}},
    {iso: 'GM',	value: 'Gambia', currency: 'USD', zone: 'ROW', label: { en: 'Gambia', fr: null, de: null}},
    {iso: 'GN',	value: 'Guinea', currency: 'USD', zone: 'ROW', label: { en: 'Guinea', fr: null, de: null}},
    {iso: 'GP',	value: 'Guadeloupe', currency: 'USD', zone: 'ROW', label: { en: 'Guadeloupe', fr: null, de: null}},
    {iso: 'GQ',	value: 'Equatorial Guinea', currency: 'USD', zone: 'ROW', label: { en: 'Equatorial Guinea', fr: null, de: null}},
    {iso: 'GR',	value: 'Greece', currency: 'EUR', zone: 'SEU', label: { en: 'Greece', fr: null, de: null}},
    {iso: 'GS',	value: 'South Georgia and the South Sandwich Islands', currency: 'USD', zone: 'ROW', label: { en: 'South Georgia and the South Sandwich Islands', fr: null, de: null}},
    {iso: 'GT',	value: 'Guatemala', currency: 'USD', zone: 'LATAM', label: { en: 'Guatemala', fr: null, de: null}},
    {iso: 'GW',	value: 'Guinea-Bissau', currency: 'USD', zone: 'ROW', label: { en: 'Guinea-Bissau', fr: null, de: null}},
    {iso: 'GY',	value: 'Guyana', currency: 'USD', zone: 'ROW', label: { en: 'Guyana', fr: null, de: null}},
    {iso: 'HM',	value: 'Heard Island and McDonald Islands', currency: 'USD', zone: 'ROW', label: { en: 'Heard Island and McDonald Islands', fr: null, de: null}},
    {iso: 'HN',	value: 'Honduras', currency: 'USD', zone: 'ROW', label: { en: 'Honduras', fr: null, de: null}},
    {iso: 'HR',	value: 'Croatia', currency: 'EUR', zone: 'EEU', label: { en: 'Croatia', fr: null, de: null}},
    {iso: 'HT',	value: 'Haiti', currency: 'USD', zone: 'ROW', label: { en: 'Haiti', fr: null, de: null}},
    {iso: 'HU',	value: 'Hungary', currency: 'EUR', zone: 'EEU', label: { en: 'Hungary', fr: null, de: null}},
    {iso: 'ID',	value: 'Indonesia', currency: 'USD', zone: 'ROW', label: { en: 'Indonesia', fr: null, de: null}},
    {iso: 'IE',	value: 'Ireland', currency: 'EUR', zone: 'UKIRE', label: { en: 'Ireland', fr: null, de: null}},
    {iso: 'IL',	value: 'Israel', currency: 'USD', zone: 'ROW', label: { en: 'Israel', fr: null, de: null}},
    {iso: 'IM',	value: 'Isle of Man', currency: 'USD', zone: 'ROW', label: { en: 'Isle of Man', fr: null, de: null}},
    {iso: 'IN',	value: 'India', currency: 'USD', zone: 'APAC', label: { en: 'India', fr: null, de: null}},
    {iso: 'IO',	value: 'British Indian Ocean Territory', currency: 'USD', zone: 'ROW', label: { en: 'British Indian Ocean Territory', fr: null, de: null}},
    {iso: 'IQ',	value: 'Iraq', currency: 'USD', zone: 'ROW', label: { en: 'Iraq', fr: null, de: null}},
    {iso: 'IS',	value: 'Iceland', currency: 'EUR', zone: 'ROEU', label: { en: 'Iceland', fr: null, de: null}},
    {iso: 'IT',	value: 'Italy', currency: 'EUR', zone: 'SEU', label: { en: 'Italy', fr: null, de: null}},
    {iso: 'JE',	value: 'Jersey', currency: 'USD', zone: 'ROW', label: { en: 'Jersey', fr: null, de: null}},
    {iso: 'JM',	value: 'Jamaica', currency: 'USD', zone: 'ROW', label: { en: 'Jamaica', fr: null, de: null}},
    {iso: 'JO',	value: 'Jordan', currency: 'USD', zone: 'ROW', label: { en: 'Jordan', fr: null, de: null}},
    {iso: 'JP',	value: 'Japan', currency: 'USD', zone: 'APAC', label: { en: 'Japan', fr: null, de: null}},
    {iso: 'KE',	value: 'Kenya', currency: 'USD', zone: 'ROW', label: { en: 'Kenya', fr: null, de: null}},
    {iso: 'KG',	value: 'Kyrgyzstan', currency: 'USD', zone: 'ROW', label: { en: 'Kyrgyzstan', fr: null, de: null}},
    {iso: 'KH',	value: 'Cambodia', currency: 'USD', zone: 'ROW', label: { en: 'Cambodia', fr: null, de: null}},
    {iso: 'KI',	value: 'Kiribati', currency: 'USD', zone: 'ROW', label: { en: 'Kiribati', fr: null, de: null}},
    {iso: 'KM',	value: 'Comoros', currency: 'USD', zone: 'ROW', label: { en: 'Comoros', fr: null, de: null}},
    {iso: 'KN',	value: 'Saint Kitts and Nevis', currency: 'USD', zone: 'ROW', label: { en: 'Saint Kitts and Nevis', fr: null, de: null}},
    {iso: 'KR',	value: 'Korea, Republic of', currency: 'USD', zone: 'ROW', label: { en: 'Korea, Republic of', fr: null, de: null}},
    {iso: 'KW',	value: 'Kuwait', currency: 'USD', zone: 'ROW', label: { en: 'Kuwait', fr: null, de: null}},
    {iso: 'KY',	value: 'Cayman Islands', currency: 'USD', zone: 'ROW', label: { en: 'Cayman Islands', fr: null, de: null}},
    {iso: 'KZ',	value: 'Kazakhstan', currency: 'USD', zone: 'ROW', label: { en: 'Kazakhstan', fr: null, de: null}},
    {iso: 'LA',	value: 'Lao People’s Democratic Republic', currency: 'USD', zone: 'ROW', label: { en: 'Lao People\'s Democratic Republic', fr: null, de: null}},
    {iso: 'LB',	value: 'Lebanon', currency: 'USD', zone: 'ROW', label: { en: 'Lebanon', fr: null, de: null}},
    {iso: 'LC',	value: 'Saint Lucia', currency: 'USD', zone: 'ROW', label: { en: 'Saint Lucia', fr: null, de: null}},
    {iso: 'LI',	value: 'Liechtenstein', currency: 'EUR', zone: 'DACH', label: { en: 'Liechtenstein', fr: null, de: null}},
    {iso: 'LK',	value: 'Sri Lanka', currency: 'USD', zone: 'ROW', label: { en: 'Sri Lanka', fr: null, de: null}},
    {iso: 'LR',	value: 'Liberia', currency: 'USD', zone: 'ROW', label: { en: 'Liberia', fr: null, de: null}},
    {iso: 'LS',	value: 'Lesotho', currency: 'USD', zone: 'ROW', label: { en: 'Lesotho', fr: null, de: null}},
    {iso: 'LT',	value: 'Lithuania', currency: 'EUR', zone: 'EEU', label: { en: 'Lithuania', fr: null, de: null}},
    {iso: 'LU',	value: 'Luxembourg', currency: 'EUR', zone: 'Benelux', label: { en: 'Luxembourg', fr: null, de: null}},
    {iso: 'LV',	value: 'Latvia', currency: 'EUR', zone: 'EEU', label: { en: 'Latvia', fr: null, de: null}},
    {iso: 'LY',	value: 'Libya', currency: 'USD', zone: 'ROW', label: { en: 'Libya', fr: null, de: null}},
    {iso: 'MA',	value: 'Morocco', currency: 'USD', zone: 'ROW', label: { en: 'Morocco', fr: null, de: null}},
    {iso: 'MC',	value: 'Monaco', currency: 'USD', zone: 'ROW', label: { en: 'Monaco', fr: null, de: null}},
    {iso: 'MD',	value: 'Moldova, Republic of', currency: 'USD', zone: 'ROW', label: { en: 'Moldova', fr: null, de: null}},
    {iso: 'ME',	value: 'Montenegro', currency: 'USD', zone: 'ROW', label: { en: 'Montenegro', fr: null, de: null}},
    {iso: 'MF',	value: 'Saint Martin (French part)', currency: 'USD', zone: 'ROW', label: { en: 'Saint Martin', fr: null, de: null}},
    {iso: 'MG',	value: 'Madagascar', currency: 'USD', zone: 'ROW', label: { en: 'Madagascar', fr: null, de: null}},
    {iso: 'MK',	value: 'North Macedonia', currency: 'USD', zone: 'ROW', label: { en: 'North Macedonia', fr: null, de: null}},
    {iso: 'ML',	value: 'Mali', currency: 'USD', zone: 'ROW', label: { en: 'Mali', fr: null, de: null}},
    {iso: 'MM',	value: 'Myanmar', currency: 'USD', zone: 'ROW', label: { en: 'Myanmar', fr: null, de: null}},
    {iso: 'MN',	value: 'Mongolia', currency: 'USD', zone: 'ROW', label: { en: 'Mongolia', fr: null, de: null}},
    {iso: 'MO',	value: 'Macao', currency: 'USD', zone: 'ROW', label: { en: 'Macao', fr: null, de: null}},
    {iso: 'MQ',	value: 'Martinique', currency: 'USD', zone: 'ROW', label: { en: 'Martinique', fr: null, de: null}},
    {iso: 'MR',	value: 'Mauritania', currency: 'USD', zone: 'ROW', label: { en: 'Mauritania', fr: null, de: null}},
    {iso: 'MS',	value: 'Montserrat', currency: 'USD', zone: 'ROW', label: { en: 'Montserrat', fr: null, de: null}},
    {iso: 'MT',	value: 'Malta', currency: 'USD', zone: 'ROW', label: { en: 'Malta', fr: null, de: null}},
    {iso: 'MU',	value: 'Mauritius', currency: 'USD', zone: 'ROW', label: { en: 'Mauritius', fr: null, de: null}},
    {iso: 'MV',	value: 'Maldives', currency: 'USD', zone: 'ROW', label: { en: 'Maldives', fr: null, de: null}},
    {iso: 'MW',	value: 'Malawi', currency: 'USD', zone: 'ROW', label: { en: 'Malawi', fr: null, de: null}},
    {iso: 'MX',	value: 'Mexico', currency: 'USD', zone: 'LATAM', label: { en: 'Mexico', fr: null, de: null}},
    {iso: 'MY',	value: 'Malaysia', currency: 'USD', zone: 'ROW', label: { en: 'Malaysia', fr: null, de: null}},
    {iso: 'MZ',	value: 'Mozambique', currency: 'USD', zone: 'ROW', label: { en: 'Mozambique', fr: null, de: null}},
    {iso: 'NA',	value: 'Namibia', currency: 'USD', zone: 'ROW', label: { en: 'Namibia', fr: null, de: null}},
    {iso: 'NC',	value: 'New Caledonia', currency: 'USD', zone: 'ROW', label: { en: 'New Caledonia', fr: null, de: null}},
    {iso: 'NE',	value: 'Niger', currency: 'USD', zone: 'ROW', label: { en: 'Niger', fr: null, de: null}},
    {iso: 'NF',	value: 'Norfolk Island', currency: 'USD', zone: 'ROW', label: { en: 'Norfolk Island', fr: null, de: null}},
    {iso: 'NG',	value: 'Nigeria', currency: 'USD', zone: 'ROW', label: { en: 'Nigeria', fr: null, de: null}},
    {iso: 'NI',	value: 'Nicaragua', currency: 'USD', zone: 'ROW', label: { en: 'Nicaragua', fr: null, de: null}},
    {iso: 'NL',	value: 'Netherlands', currency: 'EUR', zone: 'Benelux', label: { en: 'Netherlands', fr: null, de: null}},
    {iso: 'NO',	value: 'Norway', currency: 'EUR', zone: 'Nordics', label: { en: 'Norway', fr: null, de: null}},
    {iso: 'NP',	value: 'Nepal', currency: 'USD', zone: 'ROW', label: { en: 'Nepal', fr: null, de: null}},
    {iso: 'NR',	value: 'Nauru', currency: 'USD', zone: 'ROW', label: { en: 'Nauru', fr: null, de: null}},
    {iso: 'NU',	value: 'Niue', currency: 'USD', zone: 'ROW', label: { en: 'Niue', fr: null, de: null}},
    {iso: 'NZ',	value: 'New Zealand', currency: 'USD', zone: 'APAC', label: { en: 'New Zealand', fr: null, de: null}},
    {iso: 'OM',	value: 'Oman', currency: 'USD', zone: 'ROW', label: { en: 'Oman', fr: null, de: null}},
    {iso: 'PA',	value: 'Panama', currency: 'USD', zone: 'ROW', label: { en: 'Panama', fr: null, de: null}},
    {iso: 'PE',	value: 'Peru', currency: 'USD', zone: 'ROW', label: { en: 'Peru', fr: null, de: null}},
    {iso: 'PF',	value: 'French Polynesia', currency: 'USD', zone: 'ROW', label: { en: 'French Polynesia', fr: null, de: null}},
    {iso: 'PG',	value: 'Papua New Guinea', currency: 'USD', zone: 'ROW', label: { en: 'Papua New Guinea', fr: null, de: null}},
    {iso: 'PH',	value: 'Philippines', currency: 'USD', zone: 'ROW', label: { en: 'Philippines', fr: null, de: null}},
    {iso: 'PK',	value: 'Pakistan', currency: 'USD', zone: 'ROW', label: { en: 'Pakistan', fr: null, de: null}},
    {iso: 'PL',	value: 'Poland', currency: 'EUR', zone: 'EEU', label: { en: 'Poland', fr: null, de: null}},
    {iso: 'PM',	value: 'Saint Pierre and Miquelon', currency: 'USD', zone: 'ROW', label: { en: 'Saint Pierre and Miquelon', fr: null, de: null}},
    {iso: 'PN',	value: 'Pitcairn', currency: 'USD', zone: 'ROW', label: { en: 'Pitcairn', fr: null, de: null}},
    {iso: 'PS',	value: 'Palestine', currency: 'USD', zone: 'ROW', label: { en: 'Palestine', fr: null, de: null}},
    {iso: 'PT',	value: 'Portugal', currency: 'EUR', zone: 'SEU', label: { en: 'Portugal', fr: null, de: null}},
    {iso: 'PY',	value: 'Paraguay', currency: 'USD', zone: 'ROW', label: { en: 'Paraguay', fr: null, de: null}},
    {iso: 'QA',	value: 'Qatar', currency: 'USD', zone: 'ROW', label: { en: 'Qatar', fr: null, de: null}},
    {iso: 'RE',	value: 'Reunion', currency: 'USD', zone: 'ROW', label: { en: 'Reunion', fr: null, de: null}},
    {iso: 'RO',	value: 'Romania', currency: 'USD', zone: 'ROW', label: { en: 'Romania', fr: null, de: null}},
    {iso: 'RS',	value: 'Serbia', currency: 'USD', zone: 'ROW', label: { en: 'Serbia', fr: null, de: null}},
    {iso: 'RU',	value: 'Russian Federation', currency: 'USD', zone: 'ROW', label: { en: 'Russia', fr: null, de: null}},
    {iso: 'RW',	value: 'Rwanda', currency: 'USD', zone: 'ROW', label: { en: 'Rwanda', fr: null, de: null}},
    {iso: 'SA',	value: 'Saudi Arabia', currency: 'USD', zone: 'ROW', label: { en: 'Saudi Arabia', fr: null, de: null}},
    {iso: 'SB',	value: 'Solomon Islands', currency: 'USD', zone: 'ROW', label: { en: 'Solomon Islands', fr: null, de: null}},
    {iso: 'SC',	value: 'Seychelles', currency: 'USD', zone: 'ROW', label: { en: 'Seychelles', fr: null, de: null}},
    {iso: 'SE',	value: 'Sweden', currency: 'EUR', zone: 'Nordics', label: { en: 'Sweden', fr: null, de: null}},
    {iso: 'SG',	value: 'Singapore', currency: 'USD', zone: 'ROW', label: { en: 'Singapore', fr: null, de: null}},
    {iso: 'SH',	value: 'Saint Helena, Ascension and Tristan da Cunha', currency: 'USD', zone: 'ROW', label: { en: 'Saint Helena, Ascension and Tristan da Cunha', fr: null, de: null}},
    {iso: 'SI',	value: 'Slovenia', currency: 'USD', zone: 'ROW', label: { en: 'Slovenia', fr: null, de: null}},
    {iso: 'SJ',	value: 'Svalbard and Jan Mayen', currency: 'USD', zone: 'ROW', label: { en: 'Svalbard and Jan Mayen', fr: null, de: null}},
    {iso: 'SK',	value: 'Slovakia', currency: 'USD', zone: 'ROW', label: { en: 'Slovakia', fr: null, de: null}},
    {iso: 'SL',	value: 'Sierra Leone', currency: 'USD', zone: 'ROW', label: { en: 'Sierra Leone', fr: null, de: null}},
    {iso: 'SM',	value: 'San Marino', currency: 'USD', zone: 'ROW', label: { en: 'San Marino', fr: null, de: null}},
    {iso: 'SN',	value: 'Senegal', currency: 'USD', zone: 'ROW', label: { en: 'Senegal', fr: null, de: null}},
    {iso: 'SO',	value: 'Somalia', currency: 'USD', zone: 'ROW', label: { en: 'Somalia', fr: null, de: null}},
    {iso: 'SR',	value: 'Suriname', currency: 'USD', zone: 'ROW', label: { en: 'Suriname', fr: null, de: null}},
    {iso: 'SS',	value: 'South Sudan', currency: 'USD', zone: 'ROW', label: { en: 'South Sudan', fr: null, de: null}},
    {iso: 'ST',	value: 'Sao Tome and Principe', currency: 'USD', zone: 'ROW', label: { en: 'Sao Tome and Principe', fr: null, de: null}},
    {iso: 'SV',	value: 'El Salvador', currency: 'USD', zone: 'ROW', label: { en: 'El Salvador', fr: null, de: null}},
    {iso: 'SX',	value: 'Sint Maarten (Dutch part)', currency: 'USD', zone: 'ROW', label: { en: 'Sint Maarten', fr: null, de: null}},
    {iso: 'SZ',	value: 'Eswatini', currency: 'USD', zone: 'ROW', label: { en: 'Eswatini', fr: null, de: null}},
    {iso: 'TC',	value: 'Turks and Caicos Islands', currency: 'USD', zone: 'ROW', label: { en: 'Turks and Caicos Islands', fr: null, de: null}},
    {iso: 'TD',	value: 'Chad', currency: 'USD', zone: 'ROW', label: { en: 'Chad', fr: null, de: null}},
    {iso: 'TF',	value: 'French Southern Territories', currency: 'USD', zone: 'ROW', label: { en: 'French Southern Territories', fr: null, de: null}},
    {iso: 'TG',	value: 'Togo', currency: 'USD', zone: 'ROW', label: { en: 'Togo', fr: null, de: null}},
    {iso: 'TH',	value: 'Thailand', currency: 'USD', zone: 'ROW', label: { en: 'Thailand', fr: null, de: null}},
    {iso: 'TJ',	value: 'Tajikistan', currency: 'USD', zone: 'ROW', label: { en: 'Tajikistan', fr: null, de: null}},
    {iso: 'TK',	value: 'Tokelau', currency: 'USD', zone: 'ROW', label: { en: 'Tokelau', fr: null, de: null}},
    {iso: 'TL',	value: 'Timor-Leste', currency: 'USD', zone: 'ROW', label: { en: 'Timor-Leste', fr: null, de: null}},
    {iso: 'TM',	value: 'Turkmenistan', currency: 'USD', zone: 'ROW', label: { en: 'Turkmenistan', fr: null, de: null}},
    {iso: 'TN',	value: 'Tunisia', currency: 'USD', zone: 'ROW', label: { en: 'Tunisia', fr: null, de: null}},
    {iso: 'TO',	value: 'Tonga', currency: 'USD', zone: 'ROW', label: { en: 'Tonga', fr: null, de: null}},
    {iso: 'TR',	value: 'Turkey', currency: 'USD', zone: 'ROW', label: { en: 'Turkey', fr: null, de: null}},
    {iso: 'TT',	value: 'Trinidad and Tobago', currency: 'USD', zone: 'ROW', label: { en: 'Trinidad and Tobago', fr: null, de: null}},
    {iso: 'TV',	value: 'Tuvalu', currency: 'USD', zone: 'ROW', label: { en: 'Tuvalu', fr: null, de: null}},
    {iso: 'TW',	value: 'Taiwan', currency: 'USD', zone: 'ROW', label: { en: 'Taiwan', fr: null, de: null}},
    {iso: 'TZ',	value: 'Tanzania, United Republic of', currency: 'USD', zone: 'ROW', label: { en: 'Tanzania, United Republic of', fr: null, de: null}},
    {iso: 'UA',	value: 'Ukraine', currency: 'USD', zone: 'ROW', label: { en: 'Ukraine', fr: null, de: null}},
    {iso: 'UG',	value: 'Uganda', currency: 'USD', zone: 'ROW', label: { en: 'Uganda', fr: null, de: null}},
    {iso: 'US',	value: 'United States', currency: 'USD', zone: 'NA', label: { en: 'United States', fr: null, de: null}},
    {iso: 'UY',	value: 'Uruguay', currency: 'USD', zone: 'ROW', label: { en: 'Uruguay', fr: null, de: null}},
    {iso: 'UZ',	value: 'Uzbekistan', currency: 'USD', zone: 'ROW', label: { en: 'Uzbekistan', fr: null, de: null}},
    {iso: 'VA',	value: 'Holy See (Vatican City State)', currency: 'USD', zone: 'ROW', label: { en: 'Holy See (Vatican City State)', fr: null, de: null}},
    {iso: 'VC',	value: 'Saint Vincent and the Grenadines', currency: 'USD', zone: 'ROW', label: { en: 'Saint Vincent and the Grenadines', fr: null, de: null}},
    {iso: 'VE',	value: 'Venezuela, Bolivarian Republic of', currency: 'USD', zone: 'ROW', label: { en: 'Venezuela', fr: null, de: null}},
    {iso: 'VG',	value: 'Virgin Islands, British', currency: 'USD', zone: 'ROW', label: { en: 'Virgin Islands, British', fr: null, de: null}},
    {iso: 'VN',	value: 'Vietnam', currency: 'USD', zone: 'ROW', label: { en: 'Vietnam', fr: null, de: null}},
    {iso: 'VU',	value: 'Vanuatu', currency: 'USD', zone: 'ROW', label: { en: 'Vanuatu', fr: null, de: null}},
    {iso: 'WF',	value: 'Wallis and Futuna', currency: 'USD', zone: 'ROW', label: { en: 'Wallis and Futuna', fr: null, de: null}},
    {iso: 'WS',	value: 'Samoa', currency: 'USD', zone: 'ROW', label: { en: 'Samoa', fr: null, de: null}},
    {iso: 'XK',	value: 'Kosovo', currency: 'USD', zone: 'ROW', label: { en: 'Kosovo', fr: null, de: null}},
    {iso: 'YE',	value: 'Yemen', currency: 'USD', zone: 'ROW', label: { en: 'Yemen', fr: null, de: null}},
    {iso: 'YT',	value: 'Mayotte', currency: 'USD', zone: 'ROW', label: { en: 'Mayotte', fr: null, de: null}},
    {iso: 'ZA',	value: 'South Africa', currency: 'USD', zone: 'ROW', label: { en: 'South Africa', fr: null, de: null}},
    {iso: 'ZM',	value: 'Zambia', currency: 'USD', zone: 'ROW', label: { en: 'Zambia', fr: null, de: null}},
    {iso: 'ZW',	value: 'Zimbabwe', currency: 'USD', zone: 'ROW', label: { en: 'Zimbabwe', fr: null, de: null}}
];